<template>
    <div>
        <a href="https://www.linkedin.com/company/stay-marquis" target="_blank" class="me-3" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
        <a href="https://www.facebook.com/StayMarquis" target="_blank" class="me-3" aria-label="FaceBook"><i class="fab fa-facebook-f"></i></a>
        <a href="https://www.instagram.com/staymarquis" target="_blank" class="me-3" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
        <a href="https://g.page/r/CVhqMqiRU61mEAg" target="_blank" aria-label="Google"><i class="fab fa-google"></i></a>
    </div>
</template>